import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { dsClass } from '../../constants/dsClasses.js';
import { approverContactMsg, t } from '../../i18n/index.js';
import { rhfErrorsToStringMap } from '../utils.js';
import { ContactDropdown } from './ContactDropdown.js';
import type { Contact } from '../../../generated/api/models.js';

interface ApproverContactProps {
  contacts: Contact[];
  setApproverContact: (approverContact: string) => void;
  setApproverContactValidationErrors: (errors: { [fieldName: string]: string }) => void;
}

export const ApproverContactDropdown = ({
  contacts,
  setApproverContact,
  setApproverContactValidationErrors,
}: ApproverContactProps) => {
  const {
    formState: { errors },
  } = useFormContext();
  const approverContact = useWatch({ name: 'approverContact' });

  useEffect(() => {
    setApproverContactValidationErrors(rhfErrorsToStringMap(errors));
    if (approverContact) {
      setApproverContact(approverContact);
    }
  }, [approverContact, errors, setApproverContact, setApproverContactValidationErrors]);

  return (
    <ContactDropdown
      canAddNewContacts={false}
      className={dsClass.MARGIN_0}
      name="approverContact"
      labelText={t.GOZ7(approverContactMsg)}
      contacts={contacts}
    />
  );
};
